import { render, staticRenderFns } from "./MaClass.vue?vue&type=template&id=aff845b4&scoped=true"
import script from "./MaClass.vue?vue&type=script&lang=js"
export * from "./MaClass.vue?vue&type=script&lang=js"
import style0 from "./MaClass.vue?vue&type=style&index=0&id=aff845b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff845b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aff845b4')) {
      api.createRecord('aff845b4', component.options)
    } else {
      api.reload('aff845b4', component.options)
    }
    module.hot.accept("./MaClass.vue?vue&type=template&id=aff845b4&scoped=true", function () {
      api.rerender('aff845b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/MaClass.vue"
export default component.exports